<script lang="ts">
	import { Button, ButtonType } from '@repo/commons/components'

	type Props = {
		disabled?: boolean
		playDisabled?: boolean
		stepDisabled?: boolean
		isRunning?: boolean
		onPlayClicked: (() => void) | null
		onStopClicked?: (() => void) | null
		onStepClicked: (() => void) | null
		onRestartClicked: (() => void) | null
	}

	let {
		disabled = false,
		playDisabled = false,
		stepDisabled = false,
		isRunning = false,
		onPlayClicked = null,
		onStopClicked = null,
		onStepClicked = null,
		onRestartClicked = null
	}: Props = $props()
</script>

<div class="icons-container">
	{#if isRunning}
		<Button
			buttonType={ButtonType.SECONDARY_OUTLINE}
			iconProps={{ name: 'stop', size: 'sm', class: 'text-[#002C4D80]' }}
			onclick={() => onStopClicked?.()}
		/>
	{:else}
		<Button
			disabled={disabled || playDisabled}
			buttonType={ButtonType.SECONDARY_OUTLINE}
			iconProps={{ name: 'playAudio', size: 'sm', class: 'text-[#002C4D80]' }}
			onclick={() => onPlayClicked?.()}
		/>
	{/if}
	<Button
		disabled={disabled || stepDisabled}
		buttonType={ButtonType.SECONDARY_OUTLINE}
		iconProps={{ name: 'step', size: 'sm', class: 'text-[#002C4D80]' }}
		onclick={() => onStepClicked?.()}
	/>
	<Button
		{disabled}
		buttonType={ButtonType.SECONDARY_OUTLINE}
		iconProps={{ name: 'restart', size: 'sm', class: 'text-[#002C4D80]' }}
		onclick={() => onRestartClicked?.()}
	/>
</div>

<style>
	.icons-container {
		@apply inline-flex items-center gap-2;
	}
</style>
